import {
  getShellOverride,
  shellModeFor,
  MOBILE_QUERY,
} from '../mobile/useShellMode';

/**
 * Whether the mobile shell should mount.
 * Prefer useShellMode() in React; this is for non-hook call sites.
 */
export function shouldUseMobileLayout(): boolean {
  if (typeof window === 'undefined') return false;
  return (
    shellModeFor(window.matchMedia(MOBILE_QUERY).matches, getShellOverride()) ===
    'mobile'
  );
}

export function isPWAInstalled(): boolean {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true
  );
}
